import "./DesktopNavbar.scss";

import gsap from "gsap";
import React, { useEffect, useRef, useState } from "react";

import { Logo } from "../../../assets/svg/svgIcons";
import useAnimatedNavigate from "../../../hooks/useAnimatedNavigate";
import useAnimation from "../../../hooks/useAnimation";
import ElementNavBar, { LanguageButton } from "../ElementNavbar/ElementNavbar";
import navItems from "../NavItems";

const DesktopNavbar: React.FC = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("EN");
  const navbarRef = useRef<HTMLDivElement>(null);

  const changeLanguage = (lang: string) => {
    setSelectedLanguage(lang);
  };
  const { useHoverAnimation } = useAnimation();
  const barRef = useRef(null);

  useHoverAnimation([barRef]);
  const animatedNavigate = useAnimatedNavigate();

  const handleClick = () => {
    animatedNavigate("/");
  };

  useEffect(() => {
    setTimeout(() => {
      if (navbarRef.current) {
        gsap.fromTo(
          navbarRef.current,
          { y: -50, opacity: 0 },
          { y: 0, opacity: 1, duration: 1, ease: "power1.out" },
        );
      }
    }, 200);
  }, []);

  return (
    <nav
      className="desktopNavbar"
      role="navigation"
      aria-label="Site Navigation"
      ref={navbarRef}
    >
      <div className="navbarLeft">
        <Logo className="navTitle" onClick={handleClick} />

        {navItems
          .filter((item) => item.className !== "products")
          .map((item) => (
            <ElementNavBar
              key={item.href || ""}
              href={item.href || ""}
              texts={item.texts}
              page={item.page}
              className={item.className}
            />
          ))}
      </div>
      <div className="navbarRight">
        {navItems
          .filter((item) => item.className === "products")
          .map((item) => (
            <div className="dropdown" key={item.href}>
              <ElementNavBar
                href={item.href}
                texts={item.texts}
                page={item.page}
                className={item.className}
                onLinkClick={() => {}}
                ref={barRef}
              />
            </div>
          ))}

        <LanguageButton />
      </div>
    </nav>
  );
};

export default React.memo(DesktopNavbar);
